import { Link, useLocation, useNavigate, useParams } from "react-router";
import { my_routes } from "../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import { deleteMemory, getMemoryByID } from "../../api/memory";
import { toast } from "sonner";
import {
  createMemoryOrPV,
  deleteFileAttachementByID,
  getFileAttachementByName,
} from "../../api/fileAttachement";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import EditMemoryModal from "./editMemoryModal";
import withPermission from "../../core/common/autorisations/withPermission";
import { openSupportInNewTab } from "../../helper/supportHelper";
import { AxiosError } from "axios";

//bouton proteger pour ajouter un fichier memoire
const ProtectedBtnAddMemoireFileAttachment = withPermission(
  (props: any) => (
    <button
      type="button"
      className="btn btn-primary"
      onClick={() => {
        const input = document.createElement("input");
        input.type = "file";
        input.multiple = false;
        input.accept = "application/pdf,.pdf";
        //  filtrer les fichiers non acceptés
        input.onchange = async (e: any) => {
          const files: FileList = e.target.files;
          const maxSize = 10 * 1024 * 1024; // 10 Mo
          const oversized: string[] = [];
          const invalidType: string[] = [];
          const validFiles: File[] = [];

          //  filtrer les fichiers non acceptés
          Array.from(files).forEach((file) => {
            const isPdf =
              file.type === "application/pdf" ||
              file.name.toLowerCase().endsWith(".pdf");

            if (!isPdf) {
              invalidType.push(file.name);
              return;
            }

            if (file.size > maxSize) {
              oversized.push(file.name);
              return;
            }

            validFiles.push(file);
          });

          // ❌ Fichiers non PDF
          if (invalidType.length) {
            toast.error(
              `Seuls les fichiers PDF sont autorisés : ${invalidType.join(", ")}`,
            );
          }

          // ❌ Fichiers trop lourds
          if (oversized.length) {
            toast.error(
              `Fichier(s) trop lourd(s) (max 10 Mo) : ${oversized.join(", ")}`,
            );
          }
          //  ajouter les fichiers valides
          if (validFiles.length) {
            await props.AddSupport(validFiles, "Memory", props.id);
          }
        };
        input.click();
      }}
    >
      <i className="ti ti-upload me-1" />
      Ajouter un fichier
    </button>
  ),
  [buildPermission(Resource.MEMOIRE, Action.UPDATE)],
  "masquer",
);

//bouton proteger pour ajouter un fichier de proces verbale
const ProtectedBtnAddPVFileAttachment = withPermission(
  (props: any) => (
    <button
      className="btn btn-sm btn-primary d-flex align-items-center"
      onClick={() => {
        const input = document.createElement("input");
        input.type = "file";
        input.multiple = false;
        input.accept = "application/pdf,.pdf";
        //  filtrer les fichiers non acceptés
        input.onchange = async (e: any) => {
          const files: FileList = e.target.files;
          const maxSize = 10 * 1024 * 1024; // 10 Mo
          const oversized: string[] = [];
          const invalidType: string[] = [];
          const validFiles: File[] = [];

          //  filtrer les fichiers non acceptés
          Array.from(files).forEach((file) => {
            const isPdf =
              file.type === "application/pdf" ||
              file.name.toLowerCase().endsWith(".pdf");

            if (!isPdf) {
              invalidType.push(file.name);
              return;
            }

            if (file.size > maxSize) {
              oversized.push(file.name);
              return;
            }

            validFiles.push(file);
          });

          // ❌ Fichiers non PDF
          if (invalidType.length) {
            toast.error(
              `Seuls les fichiers PDF sont autorisés : ${invalidType.join(", ")}`,
            );
          }

          // ❌ Fichiers trop lourds
          if (oversized.length) {
            toast.error(
              `Fichier(s) trop lourd(s) (max 10 Mo) : ${oversized.join(", ")}`,
            );
          }
          //  ajouter les fichiers valides
          if (validFiles.length) {
            await props.AddSupport(validFiles, "PV", props.memoryDetail.pv.id);
          }
        };
        input.click();
      }}
    >
      <i className="ti ti-plus me-1" />
      Ajouter un PV
    </button>
  ),
  [buildPermission(Resource.MEMOIRE, Action.UPDATE)],
  "masquer",
);

//bouton proteger pour supprimer un memoire
const ProtectedBtnDeleteMemoire = withPermission(
  (props: any) => (
    <button
      type="button"
      className="btn btn-sm btn-outline-danger"
      onClick={props.confirmDeleteMemory}
    >
      <i className="ti ti-trash" />
    </button>
  ),
  [buildPermission(Resource.MEMOIRE, Action.DELETE)],
  "masquer",
);

//bouton proteger pour supprimer le fichier du memoire
const ProtectedBtnDeleteFileMemoire = withPermission(
  (props: any) => (
    <button
      className="btn btn-light btn-sm"
      onClick={() => props.confirmDeleteSupport(props.memoryFile, "Memory")}
    >
      <i className="ti ti-trash" />
    </button>
  ),
  [
    buildPermission(Resource.MEMOIRE, Action.UPDATE),
    buildPermission(Resource.MEMOIRE, Action.DELETE),
  ],
  "masquer",
);

//bouton proteger pour modifier le fichier du memoire
const ProtectedBtnUpdateFileMemoire = withPermission(
  (props: any) => (
    <button
      className="btn btn-light btn-sm"
      onClick={() => {
        props.setShowEdit(true);
        props.setEditMemory(props.memory.id);
      }}
    >
      <i className="ti ti-edit" />
    </button>
  ),
  [
    buildPermission(Resource.MEMOIRE, Action.UPDATE),
    buildPermission(Resource.MEMOIRE, Action.DELETE),
  ],
  "masquer",
);

//bouton proteger pour supprimer le fichier du proces verbale
const ProtectedBtnDeletePV = withPermission(
  (props: any) => (
    <button
      className="btn btn-sm btn-outline-danger"
      onClick={props.confirmDeleteSupport}
    >
      <i className="ti ti-trash" />
    </button>
  ),
  [
    buildPermission(Resource.MEMOIRE, Action.UPDATE),
    buildPermission(Resource.MEMOIRE, Action.DELETE),
  ],
  "masquer",
);

const MemoryDetails = () => {
  const routes = my_routes;
  const location = useLocation();
  // === SweetAlert (confirmations) ===
  const MySwal = withReactContent(Swal);

  const navigate = useNavigate();

  // === Paramètres d'URL ===
  const { id } = useParams(); // On récupère l'id de l'URL

  // === States principaux ===
  const [memoryDetail, setMemoryDetail] = useState<any>(null);
  const [editMemory, setEditMemory] = useState("");
  const [showEdit, setShowEdit] = useState(false);
  const [iframeSrc, setIframeSrc] = useState<string>("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données
  const [filesLoading, setFilesLoading] = useState<any>({});

  // === Reload global (à éviter si possible) ===
  const reloadData = () => setRefreshKey((prev) => prev + 1);

  useEffect(() => {
    // On attend que id soit défini
    if (!id) return;
    const fetchMemoryDetails = async () => {
      try {
        setIsLoading(true);

        const response = await getMemoryByID(id);
        const memoryData = response.data || [];
        // console.log("Données brutes reçues : ", memoryData);

        setMemoryDetail(memoryData);

        if (!memoryData?.file?.filename) {
          setIframeSrc("");
          return;
        }

        const memoryFile = await getFileAttachementByName(
          "Memory",
          memoryData?.file.filename,
          buildPermissionContext(Resource.MEMOIRE, Action.READ),
        );
        // console.log("Fichier mémoire récupéré : ", memoryFile);
        if (!memoryFile?.temporaryUrl) {
          setIframeSrc("");
          return;
        }

        setIframeSrc(memoryFile.temporaryUrl);
      } catch (error: any) {
        // console.log("erreur de chargement du mémoire : ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );

        // Option: reset la mémoire en cas d'erreur
        setMemoryDetail(null);
      } finally {
        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
      }
    };

    fetchMemoryDetails();

    return () => {
      // nettoyage quand on quitte la page
      setIframeSrc("");
    };
  }, [refreshKey, id]);

  const confirmDeleteMemory = () => {
    MySwal.fire({
      title: "Supprimer ce mémoire ?",
      text: "Cette action est irréversible.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });

        try {
          await deleteMemory(id); // ou id depuis useParams
          toast.success("Mémoire supprimé avec succès");
          MySwal.fire({
            title: "Mémoire supprimé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          navigate(routes.memoryList); // retour liste
        } catch (error: any) {
          const err = error as AxiosError<any>;
          // console.log(err);

          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text:
              err.response?.data?.message ||
              err.response?.data?.error ||
              "Une erreur est survenue, réessayez plus tard",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const getMention = (rawNote: any) => {
    const note = Number(rawNote);
    if (Number.isNaN(note)) return "Non classé";
    if (note < 10) return "Insuffisant";
    if (note < 12) return "Passable";
    if (note < 14) return "Assez bien";
    if (note < 16) return "Bien";
    if (note < 18) return "Très bien";
    return "Excellent";
  };

  const AddSupport = async (data: any, entity: string, entity_id: any) => {
    try {
      const formData = new FormData();
      data.forEach((file: any) => formData.append("files", file));
      formData.append("entity_id", entity_id || "");
      formData.append("entity_type", entity);

      await createMemoryOrPV(
        formData,
        buildPermissionContext(Resource.MEMOIRE, Action.UPDATE),
      );
      reloadData();
      toast.success("Pièces jointe ajoutés avec succès");
    } catch (error: any) {
      // console.log("erreur d'ajout de support : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // === Suppression d'une pièce jointe ===
  const confirmDeleteSupport = (support: any, type: string) => {
    MySwal.fire({
      title: "Supprimer pièce jointe ?",
      text: "Voulez-vous vraiment supprimer cette pièce jointe ?",
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      cancelButtonText: "Annuler",
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          await deleteFileAttachementByID(
            support.id,
            buildPermissionContext(Resource.MEMOIRE, Action.UPDATE),
          );
          if (type == "Memory") {
            setIframeSrc("");
            reloadData();
          } else if (type == "PV") {
            reloadData();
          }
          MySwal.fire("Supprimé !", "Pièce jointe supprimée.", "success");
        } catch (error) {
          // console.log(error)
          MySwal.fire(
            "Erreur",
            "Impossible de supprimer la pièce jointe.",
            "error",
          );
        }
      }
    });
  };

  // === Voir / Télécharger un support ===
  const handleGetSupportFile = async (
    fileId: string,
    fileName: string,
    entity: string,
  ) => {
    try {
      setFilesLoading((prev: any) => ({ ...prev, [fileId]: "open" }));

      await openSupportInNewTab({
        entityType: entity,
        fileName,
        context: buildPermissionContext(Resource.MEMOIRE, Action.READ),
      });
    } catch (error: any) {
      console.log("Erreur lors de l'ouverture du fichier: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setFilesLoading((prev: any) => ({ ...prev, [fileId]: "" }));
    }
  };

  if (isLoading) {
    return (
      <div className="card">
        <div className="card-body py-5 text-center">
          <span className="spinner-border text-primary me-2" role="status" />
          Chargement du mémoire...
        </div>
      </div>
    );
  }

  if (!memoryDetail?.memory) {
    return <div className="alert alert-info">Aucun mémoire trouvé.</div>;
  }

  const memory = memoryDetail.memory;
  const memoryFile = memoryDetail.file || null;
  const pvFile = memoryDetail.pvFile || null;

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* ===== Contenu ===== */}
        <div className="row g-3">
          {/* ===== PDF Viewer ===== */}
          <div className="col-lg-9">
            <div className="card h-100">
              <div className="card-body p-0">
                {/* Toolbar */}
                <div className="border-bottom p-2 d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-3">
                    {/* Bouton retour rond */}
                    <Link
                      to={routes.memoryList}
                      className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: 36, height: 36 }}
                    >
                      <i className="ti ti-arrow-left fs-18" />
                    </Link>

                    {/* Icône PDF */}
                    <i className="ti ti-file-type-pdf text-danger fs-20" />

                    {/* Nom du fichier */}
                    <strong className="text-truncate">
                      {memoryFile?.fileOriginalName || "Aucun document"}
                    </strong>
                  </div>

                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-light btn-sm"
                      onClick={(e) => {
                        e.preventDefault();
                        handleGetSupportFile(
                          memoryFile?.id,
                          memoryFile?.filename,
                          "Memory",
                        );
                      }}
                    >
                      <i className="ti ti-download" />
                    </button>
                    <ProtectedBtnUpdateFileMemoire
                      memory={memory}
                      setShowEdit={setShowEdit}
                      setEditMemory={setEditMemory}
                    />
                    <ProtectedBtnDeleteFileMemoire
                      confirmDeleteSupport={confirmDeleteSupport}
                      memoryFile={memoryFile}
                    />
                  </div>
                </div>
                {iframeSrc ? (
                  <>
                    {/* PDF iframe */}
                    <iframe
                      src={iframeSrc}
                      title="Mémoire PDF"
                      style={{
                        width: "100%",
                        height: "75vh",
                        border: "none",
                      }}
                    />
                  </>
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ minHeight: "65vh" }}
                  >
                    <div
                      className="card border-0 shadow-sm w-100"
                      style={{ maxWidth: "520px" }}
                    >
                      <div className="card-body text-center py-5">
                        <i className="ti ti-file-off fs-1 text-muted mb-3 d-block" />
                        <h6 className="mb-1">
                          Aucun fichier associé à ce mémoire
                        </h6>
                        <p className="text-muted mb-3">
                          Ajoutez le document du mémoire pour pouvoir le
                          prévisualiser ici.
                        </p>
                        <ProtectedBtnAddMemoireFileAttachment
                          AddSupport={AddSupport}
                          id={id}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ===== Sidebar détails ===== */}
          <div className="col-lg-3">
            <div className="card h-100">
              <div className="card-header">
                {/* Titre */}
                <div className="d-flex align-items-start justify-content-between gap-2">
                  <h5 className="mb-1">{memory.title || "Titre du mémoire"}</h5>
                  <ProtectedBtnDeleteMemoire
                    confirmDeleteMemory={confirmDeleteMemory}
                  />
                </div>
              </div>
              <div className="card-body">
                {/* Infos */}
                <ul className="list-unstyled mb-4">
                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-user me-2 mt-1" />
                    <div>
                      <small className="text-muted">Auteur</small>
                      <div className="fw-semibold">
                        {memory.StudentProfil.firstname}{" "}
                        {memory.StudentProfil.lastname}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-user-check me-2 mt-1" />
                    <div>
                      <small className="text-muted">Encadrant</small>
                      <div className="fw-semibold">
                        {memory.director_memory}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-users me-2 mt-1" />
                    <div>
                      <small className="text-muted">Membres du Jury</small>
                      <div className="fw-semibold">
                        {memory.member_of_jury1}
                      </div>
                      <div className="fw-semibold">
                        {memory.member_of_jury2}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-school me-2 mt-1" />
                    <div>
                      <small className="text-muted">Classe - Filière</small>
                      <div className="fw-semibold">
                        {memory.Class.Level.label} - {memory.Class.label}{" "}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-calendar me-2 mt-1" />
                    <div>
                      <small className="text-muted">Année académique</small>
                      <div className="fw-semibold">
                        {memory.Class.Level.AcademicYear.label}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-clock me-2 mt-1" />
                    <div>
                      <small className="text-muted">Date et Lieu</small>
                      <div className="fw-semibold">
                        {new Date(memory?.defense_date).toLocaleDateString(
                          "fr-FR",
                        )}{" "}
                        · {memory.place_of_defense}{" "}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-clock me-2 mt-1" />
                    <div>
                      <small className="text-muted">Date d'ajout</small>
                      <div className="fw-semibold">
                        {new Date(memory?.createdAt).toLocaleDateString(
                          "fr-FR",
                        )}
                      </div>
                    </div>
                  </li>

                  <li className="d-flex align-items-start mb-3">
                    <i className="ti ti-eye me-2 mt-1" />
                    <div>
                      <small className="text-muted">Note de soutenance</small>
                      <div className="fw-semibold">
                        {Number(memory.note).toFixed(2)} (
                        {getMention(memory.note)})
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="card-footer p-0">
                {!pvFile ? (
                  <div className="d-flex flex-column align-items-center justify-content-center text-center p-3 border border-dashed rounded bg-light">
                    {/* Icône */}
                    <span className="bg-soft-secondary text-muted avatar avatar-lg mb-3 rounded-circle d-flex align-items-center justify-content-center">
                      <i className="ti ti-file-off fs-24" />
                    </span>

                    {/* Message */}
                    <p className="mb-2 text-muted">
                      Aucun Procès-Verbal disponible pour le moment
                    </p>

                    {/* Bouton ajouter */}
                    <ProtectedBtnAddPVFileAttachment
                      AddSupport={AddSupport}
                      memoryDetail={memoryDetail}
                    />
                  </div>
                ) : (
                  <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                    {/* Icône ou miniature du fichier */}
                    <div className="d-flex align-items-center">
                      <span className="bg-soft-primary text-primary avatar avatar-md me-2 br-5 flex-shrink-0">
                        <i className="ti ti-file-text fs-16" />{" "}
                        {/* Icône du type de fichier */}
                      </span>

                      {/* Nom du fichier */}
                      <div>
                        <span className="fs-12 text-muted">Fichier PV</span>
                        {/* <p
                                                    className="mb-0 text-dark text-truncate"
                                                    style={{ maxWidth: "200px" }}
                                                    title={pvFile.fileOriginalName}
                                                >
                                                    {pvFile.fileOriginalName}
                                                </p> */}
                      </div>
                    </div>

                    {/* Boutons actions */}
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          handleGetSupportFile(
                            pvFile?.id,
                            pvFile?.filename,
                            "PV",
                          );
                        }}
                      >
                        <i className="ti ti-eye" />
                      </button>
                      <ProtectedBtnDeletePV
                        confirmDeleteSupport={() =>
                          confirmDeleteSupport(pvFile, "PV")
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* === Modale d'édition === */}
      <EditMemoryModal
        show={showEdit}
        idMemory={editMemory}
        onClose={() => setShowEdit(false)}
        onSaved={reloadData}
      />
    </div>
  );
};

export default MemoryDetails;
